export const LINK_TYPE_AD = 'ad' as const;
export const AD_LINK = 'AD_LINK' as const;
